(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-winner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindMainProductGalleries = () => {
      document.querySelectorAll('[data-product-gallery-shell]').forEach((shell) => {
        if (shell.dataset.galleryBound === 'true') return;
        shell.dataset.galleryBound = 'true';

        const gallery = shell.querySelector('[data-product-gallery]');
        if (!gallery) return;

        const prev = shell.querySelector('[data-gallery-prev]');
        const next = shell.querySelector('[data-gallery-next]');
        const current = shell.querySelector('[data-gallery-current]');
        let frame = 0;

        const update = () => {
          frame = 0;
          const width = gallery.clientWidth || 1;
          const lastIndex = Math.max(gallery.children.length - 1, 0);
          const index = Math.min(Math.round(gallery.scrollLeft / width), lastIndex);

          if (current) current.textContent = String(index + 1);
          if (prev) prev.disabled = index <= 0;
          if (next) next.disabled = index >= lastIndex;
        };

        const queueUpdate = () => {
          if (frame) return;
          frame = window.requestAnimationFrame(update);
        };

        const scrollBySlide = (direction) => {
          gallery.scrollBy({ left: gallery.clientWidth * direction, behavior: 'smooth' });
        };

        if (prev) prev.addEventListener('click', () => scrollBySlide(-1));
        if (next) next.addEventListener('click', () => scrollBySlide(1));
        gallery.addEventListener('scroll', queueUpdate, { passive: true });
        window.addEventListener('resize', queueUpdate);
        update();
      });
    };

    const euro = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });

    const bindPackPickers = () => {
      document.querySelectorAll('[data-pack-picker]').forEach((picker) => {
        if (picker.dataset.packBound === 'true') return;
        picker.dataset.packBound = 'true';

        const target = document.querySelector(picker.dataset.quantityTarget);
        const inputs = picker.querySelectorAll('[data-pack-quantity]');
        if (inputs.length === 0) return;

        const sync = () => {
          const checked = picker.querySelector('[data-pack-quantity]:checked');
          if (!checked) return;
          const quantity = checked.dataset.packQuantity || checked.value || '1';
          if (target) {
            target.value = quantity;
            target.dispatchEvent(new Event('change', { bubbles: true }));
          }
          // live total on the CTA button (strong conversion signal)
          const cents = parseInt(checked.dataset.packTotal || '0', 10);
          if (cents > 0) {
            document.querySelectorAll('[data-cta-price]').forEach((el) => {
              el.textContent = euro.format(cents / 100);
            });
          }
        };

        inputs.forEach((input) => input.addEventListener('change', sync));
        sync();
      });
    };

    const bindDeliveryEstimate = () => {
      const el = document.querySelector('[data-delivery-estimate]');
      if (!el || el.dataset.bound === 'true') return;
      el.dataset.bound = 'true';
      const fmt = new Intl.DateTimeFormat('es-ES', { weekday: 'short', day: 'numeric', month: 'short' });
      // Tipsa servicio 24 delivers Mon-Fri only: count WORKING days (skip Sat+Sun).
      // Window = 1-3 working days, matching the store-wide "24-72 h laborables"
      // (some Dropea products dispatch in 48h, so promising day+1/day+2 was too tight).
      const addWorkdays = (base, n) => {
        const d = new Date(base);
        while (n > 0) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) n--; }
        return d;
      };
      const from = addWorkdays(new Date(), 1);
      const to = addWorkdays(new Date(), 3);
      el.innerHTML = '&#128666; P&iacute;delo hoy y rec&iacute;belo entre <b>' + fmt.format(from) + '</b> y <b>' + fmt.format(to) + '</b>';
      el.hidden = false;
    };

    bindMainProductGalleries();
    bindPackPickers();
    bindDeliveryEstimate();
    document.addEventListener('shopify:section:load', bindMainProductGalleries);
    document.addEventListener('shopify:section:load', bindPackPickers);
    document.addEventListener('shopify:section:load', bindDeliveryEstimate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindMainProductGalleries = () => {
      document.querySelectorAll('[data-product-gallery-shell]').forEach((shell) => {
        if (shell.dataset.galleryBound === 'true') return;
        shell.dataset.galleryBound = 'true';

        const gallery = shell.querySelector('[data-product-gallery]');
        if (!gallery) return;

        const prev = shell.querySelector('[data-gallery-prev]');
        const next = shell.querySelector('[data-gallery-next]');
        const current = shell.querySelector('[data-gallery-current]');
        let frame = 0;

        const update = () => {
          frame = 0;
          const width = gallery.clientWidth || 1;
          const lastIndex = Math.max(gallery.children.length - 1, 0);
          const index = Math.min(Math.round(gallery.scrollLeft / width), lastIndex);

          if (current) current.textContent = String(index + 1);
          if (prev) prev.disabled = index <= 0;
          if (next) next.disabled = index >= lastIndex;
        };

        const queueUpdate = () => {
          if (frame) return;
          frame = window.requestAnimationFrame(update);
        };

        const scrollBySlide = (direction) => {
          gallery.scrollBy({ left: gallery.clientWidth * direction, behavior: 'smooth' });
        };

        if (prev) prev.addEventListener('click', () => scrollBySlide(-1));
        if (next) next.addEventListener('click', () => scrollBySlide(1));
        gallery.addEventListener('scroll', queueUpdate, { passive: true });
        window.addEventListener('resize', queueUpdate);
        update();
      });
    };

    const euro = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });

    const bindPackPickers = () => {
      document.querySelectorAll('[data-pack-picker]').forEach((picker) => {
        if (picker.dataset.packBound === 'true') return;
        picker.dataset.packBound = 'true';

        const target = document.querySelector(picker.dataset.quantityTarget);
        const inputs = picker.querySelectorAll('[data-pack-quantity]');
        if (inputs.length === 0) return;

        const sync = () => {
          const checked = picker.querySelector('[data-pack-quantity]:checked');
          if (!checked) return;
          const quantity = checked.dataset.packQuantity || checked.value || '1';
          if (target) {
            target.value = quantity;
            target.dispatchEvent(new Event('change', { bubbles: true }));
          }
          // live total on the CTA button (strong conversion signal)
          const cents = parseInt(checked.dataset.packTotal || '0', 10);
          if (cents > 0) {
            document.querySelectorAll('[data-cta-price]').forEach((el) => {
              el.textContent = euro.format(cents / 100);
            });
          }
        };

        inputs.forEach((input) => input.addEventListener('change', sync));
        sync();
      });
    };

    const bindDeliveryEstimate = () => {
      const el = document.querySelector('[data-delivery-estimate]');
      if (!el || el.dataset.bound === 'true') return;
      el.dataset.bound = 'true';
      const fmt = new Intl.DateTimeFormat('es-ES', { weekday: 'short', day: 'numeric', month: 'short' });
      // Tipsa servicio 24 delivers Mon-Fri only: count WORKING days (skip Sat+Sun).
      // Window = 1-3 working days, matching the store-wide "24-72 h laborables"
      // (some Dropea products dispatch in 48h, so promising day+1/day+2 was too tight).
      const addWorkdays = (base, n) => {
        const d = new Date(base);
        while (n > 0) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) n--; }
        return d;
      };
      const from = addWorkdays(new Date(), 1);
      const to = addWorkdays(new Date(), 3);
      el.innerHTML = '&#128666; P&iacute;delo hoy y rec&iacute;belo entre <b>' + fmt.format(from) + '</b> y <b>' + fmt.format(to) + '</b>';
      el.hidden = false;
    };

    bindMainProductGalleries();
    bindPackPickers();
    bindDeliveryEstimate();
    document.addEventListener('shopify:section:load', bindMainProductGalleries);
    document.addEventListener('shopify:section:load', bindPackPickers);
    document.addEventListener('shopify:section:load', bindDeliveryEstimate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    
  const bar = document.querySelector('[data-sticky-buy-bar]');
  const footer = document.querySelector('.site-footer, footer');
  if (bar && footer && 'IntersectionObserver' in window) {
    new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) bar.setAttribute('data-footer-visible', '');
        else bar.removeAttribute('data-footer-visible');
      });
    }, { rootMargin: '0px 0px -40px 0px' }).observe(footer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["winner-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-winner-page]');
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    const loadVideo = (video) => {
      if (!video || video.dataset.loaded === 'true') return;
      const source = video.querySelector('source[data-src]');
      if (!source) return;
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
      video.load();
      video.dataset.loaded = 'true';
    };

    const observer = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            loadVideo(entry.target);
            obs.unobserve(entry.target);
          });
        }, { rootMargin: '350px 0px' })
      : null;

    root.querySelectorAll('[data-winner-video]').forEach((video) => {
      if (observer) observer.observe(video); else loadVideo(video);
    });

    root.querySelectorAll('[data-winner-play]').forEach((button) => {
      button.addEventListener('click', () => {
        const wrap = button.closest('.winner-demo__media-wrap, .winner-updates__media');
        const video = wrap?.querySelector('video');
        if (!video) return;
        loadVideo(video);
        const play = () => video.play().then(() => { button.hidden = true; }).catch(() => {});
        if (video.readyState >= 2) play(); else video.addEventListener('canplay', play, { once: true });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
